import { useCallback } from 'react';
import { formatTime } from '@elfsight/widget-ui';
import { useBusinessHoursProps } from '../../business-hours-props-context';

export const useTimeFormatter = () => {
  const { timeFormat, language } = useBusinessHoursProps();

  return useCallback(
    (date: Date) => {
      // legacy, remove in https://elfsight.atlassian.net/browse/WIDGETS-2643

      // const finalTimeFormat =
      //   !timeFormat || timeFormat === 'auto' ? getUserTimeFormat() : timeFormat;
      // const formatType = finalTimeFormat === '12-hour' ? 'h:mm aaa' : 'H:mm';

      return formatTime({
        date: date,
        locale: language?.language
      });
    },
    [timeFormat, language?.language]
  );
};
